import { Button, TextField, Box, Typography } from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState, useEffect } from 'react'
import { useLoaderData, useNavigate } from 'react-router'
import { SubscriptionModel } from 'types'
import axios from 'axios'

export default function SubscriptionEditPage() {
  const navigate = useNavigate()
  const initialData = useLoaderData() as SubscriptionModel
  const [subscription, setSubscription] = useState(initialData)

  useEffect(() => {
    setSubscription(initialData)
  }, [initialData])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setSubscription((prev) => ({
      ...prev,
      [name]: name === 'name' ? value : Number(value),
    }))
  }

  const handleSubmit = () => {
    const token = localStorage.getItem('token')
    const { id, ...payload } = subscription // Exclude ID from payload for the PUT request
    axios
      .put(`${base_url}/subscription/${id}`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => navigate(`/subscription/${id}`))
      .catch((error) =>
        alert('La mise à jour a échoué: ' + error.response?.data?.message)
      )
  }

  return (
    <PageAppBar pageName="Modifier un Abonnement">
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          alignItems: 'center',
          padding: '2rem',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h5">Modifier: {subscription.name}</Typography>
        <TextField
          required
          fullWidth
          name="name"
          label="Nom de l'abonnement"
          value={subscription.name}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="price"
          label="Prix"
          type="number"
          value={subscription.price}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="maxProfiles"
          label="Nombre max de profils"
          type="number"
          value={subscription.maxProfiles}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="maxLicenses"
          label="Nombre max de licences"
          type="number"
          value={subscription.maxLicenses}
          onChange={handleChange}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          sx={{ mt: 2 }}
        >
          Sauvegarder
        </Button>
      </Box>
    </PageAppBar>
  )
}
